// Common
import React from 'react';

// Moment
import moment from 'moment';
import 'moment/locale/ru';

// Data
import data from './data/data';
import data_archive from './data/data_archive';
import output from './data/output';
import ThreeDatePicker from './three_calendar';

// Output day
import OutputDay from './output_day';
import PickNewOrder from './pick_new_order';

// Locale
// import locale from '../data/locale'
import locale from 'antd/lib/date-picker/locale/ru_RU';

// Ant
import { 
    Table,
    Typography,
    Radio,
    Select,
    Button,
    Input,
    DatePicker,
    Row, 
    Drawer,
    Col
} from 'antd';

const { Text } = Typography;
const { Option } = Select;
const Search = Input.Search;
const InputGroup = Input.Group;
// const { RangePicker } = DatePicker;


moment.locale('ru');

class Auto_Order extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            visible_output_day: false,
            visible_pick_new_order: false,
            filtered_info: {
                type: ['archive'],
                date_create: [0, 99999999999999]
            },
            search_text: '',
            sorted_info: null,
            output: [],
            selectedRowKeys: [],
            active: [],
            archive: [],
            types: {
                current: 'active'
            },
            data: {
                select: [],
                order_select: []
            },
            pagination: {
                pages: 3
            },
            event: null
        }
    }

    componentDidMount() {

        // Даты
        this.setState((state, props) => ({
            active: data,
            archive: data_archive,
            data: {
                ...state.data,
                select: data
            },
            output: output
        }))

    }

    componentDidUpdate(prevProps, prevState){

        

    }

    // Событие в range picker
    change_range_picker = (dates, dateString) => {
        // console.log(dates, dateString);
    }

    // Неактивные даты
    disabled_date(current) {
        return current && current.unix() < moment().unix() - 43200;
    }

    // Работа с таблицей
    change_events_table = (pagination, filters, sorter) => {
        
    };

    // Вывод таблицы
    render_auto_order_table(){

        const { selectedRowKeys } = this.state;
        let { filtered_info } = this.state;
        // let { sorted_info, filtered_info } = this.state;
        filtered_info = filtered_info || {};
        // sorted_info = sorted_info || {};

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState((state, props) => ({
                    selectedRowKeys,
                    data: {
                        ...state.data,
                        data_select: selectedRows
                    }
                }))
            }
        };
        
        const { pages } = this.state.pagination;
        const data = this.state.data.select;


        let columns = [
            {
                title: 'Номер заказа',
                dataIndex: 'order',
                key: 'order',
                render: order => (
                    <span>
                        <span className="item__order-number">{order.number}</span>
                        <Text type="secondary">Создан: {moment(parseInt(order.date_create)).format('DD.MM.YYYY')}</Text>
                    </span>
                ),
                filteredValue: filtered_info.date_create || null,
                onFilter: (value, record) => {
                    return filtered_info.date_create[0] <= record.order.date_create && filtered_info.date_create[1] >= record.order.date_create
                },
                sorter: (a, b) => { return a.order.number.localeCompare(b.order.number)}
            },{
                title: 'Вид',
                dataIndex: 'view',
                key: 'view',
                render: view => (
                    <span>{view}</span>
                ),
                sorter: (a, b) => { return a.view.localeCompare(b.view)}
            },{
                title: 'Статус',
                dataIndex: 'state',
                key: 'state',
                render: state => (
                    <span className="item__state">
                        <span style={{ color: (state.type === 'tobook' && '#9b9b9b') || (state.type === 'ready' && '#97dc76') }}>&bull;</span> {state.type === 'tobook' && <span>Бронь</span>}{state.type === 'ready' && <span>Готов к вып.</span>}{state.type === 'success' && <span>Выполнен</span>}
                        <br/>
                        {state.accepted && <Text style={{ fontWeight: 500 }}>Принят</Text>}
                        {state.accepted === false && <Text type="secondary">Не принят</Text>}
                        {state.check === false && <Text type="secondary">Не требует пр.</Text>}
                    </span>
                ),
                filteredValue: filtered_info.state || null,
                onFilter: (value, record) => {
                    return record.state.type.includes(value)
                },
                sorter: (a, b) => { return a.state.type.localeCompare(b.state.type)}
            },{
                title: 'Пасс.',
                dataIndex: 'passengers',
                key: 'passengers',
                render: passengers => (
                    <span>{(passengers && passengers) || '—'}</span>
                ),
                sorter: (a, b) => { return a.passengers.localeCompare(b.passengers)}
            },{
                title: 'Дата подачи',
                dataIndex: 'date_of_application',
                key: 'date_of_application',
                render: date_of_application => (
                    <span className="item__date_of_application">
                        {moment(parseInt(date_of_application)).format('DD.MM.YYYY HH:mm')} <br/>
                        <Text type="secondary">{moment(parseInt(date_of_application)).fromNow()}</Text>
                    </span>
                ),
                sorter: (a, b) => { return a.date_of_application.localeCompare(b.date_of_application)}
            },{
                title: 'Место подачи',
                dataIndex: 'place_of_supply',
                key: 'place_of_supply',
                render: place_of_supply => (
                    <span>
                        <span className="item__street">{place_of_supply.street}</span>
                        <Text type="secondary">{place_of_supply.city}</Text>
                    </span>
                ),
                sorter: (a, b) => { return a.place_of_supply.city.localeCompare(b.place_of_supply.city) || a.place_of_supply.street.localeCompare(b.place_of_supply.street)}
            }
        ];

        return (
            <div className="auto-order__table">
                <Table
                    dataSource={data}
                    pagination={{
                        pageSize: pages
                    }}
                    rowSelection={rowSelection}
                    rowKey="key"
                    columns={columns}
                    onChange={this.change_events_table}>
                </Table>
            </div>
        )
    }

    // Выбор кол-во отображаемыъ элементов в таблице
    change_auto_order_size = e => {
        this.setState((state, props) => ({
            pagination: {
                pages: e
            }
        }));
    }

    // Вывод кол-во отображаемых строк
    render_auto_order_pages(){
        return (
            <div className="auto-order__pages">
                <span className="auto-order__pages-title">Показать на странице</span>
                <Select defaultValue={this.state.pagination.pages} style={{ width: 80 }} onChange={this.change_auto_order_size}>
                    <Option value="3">3</Option>
                    <Option value="5">5</Option>
                    <Option value="10">10</Option>
                </Select>
            </div>
        )
    }

    // Поиск по номеру заказа
    handle_search_auto_order_change = e => {
        const { value } = e.target;
        this.setState((state, props) => ({
            search_text: value
        }))
    }

    // Поиск по номеру заказа
    handle_search_auto_order_search = e => {

        let types_current = this.state.types.current,
            data = this.state[types_current],
            searchText = this.state.search_text,
            reg = new RegExp(searchText, 'gi');

        this.setState((state, props) => ({
            filtered_search: !!searchText,
            data: {
                ...state.data,
                select: data.map((record) => {
                    const match = record.order.number.match(reg);
                    if (!match) {
                        return null;
                    }
                    return {
                        ...record,
                        name: (
                            <span>
                            {record.order.number.split(reg).map((text, i) => (
                                i > 0 ? [<span>{match[0]}</span>, text] : text
                            ))}
                            </span>
                        ),
                    };
                }).filter(record => !!record),
            }
        }));

    }

    // Действия с выбранными данными из таблицы
    handle_data_event = e => {
        this.setState((state, props) => ({
            event: e
        }))
    }

    // Выбор типа
    change_type_data = (e) => {
        this.setState((state, props) => ({
            types: {
                current: e.target.value
            },
            data: {
                ...state.data,
                select: this.state[e.target.value]
            }
        }));
    }

    // Выбор статуса
    handle_filter_state = (e) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                state: (e && [e]) || null
            }
        }))
    }

    // Выбор диапазона дат от
    change_filter_from_date = (date, dateString) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                date_create: [(date && parseInt(date.format('x'))) || 0, this.state.filtered_info.date_create[1]]
            }
        }))
    }

    // Выбор диапазона дат до
    change_filter_to_date = (date, dateString) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                date_create: [this.state.filtered_info.date_create[0], (date && parseInt(date.format('x'))) || 99999999999999]
            }
        }))
    }

    // Показать не рабочие дни
    show_drawer_output_day = () => {
        this.setState((state, props) => ({
            visible_output_day: true
        }))
    }

    // Спрятать не рабочие дни
    hide_drawer_output_day = () => {
        this.setState((state, props) => ({
            visible_output_day: false
        }))
    }

    // Показать подобрать новый заказ
    show_drawer_pick_new_order = () => {
        this.setState((state, props) => ({
            visible_pick_new_order: true
        }))
    }

    // Спрятать подобрать новый заказ
    hide_drawer_pick_new_order = () => {
        this.setState((state, props) => ({
            visible_pick_new_order: false
        }))
    }

    render(){

        const { output, filtered_info } = this.state;

        return (
            <div className="auto-order__wrap">
                <Drawer
                    title={<div><h2>Подобрать новый заказ</h2>Александровский Александр Александрович</div>}
                    width={896}
                    placement={'left'}
                    closable={false}
                    onClose={this.hide_drawer_pick_new_order}
                    visible={this.state.visible_pick_new_order}
                    className="auto-order"
                >
                    <Button className="exclude_ts__hide" onClick={this.hide_drawer_pick_new_order} type="primary" shape="circle" icon="close" size={'small'} />
                    <PickNewOrder hide_drawer_pick_new_order={this.hide_drawer_pick_new_order} orders={this.state.data.select} />
                </Drawer>
                <Drawer
                    title={<div><h2>Отметить нерабочие дни</h2>Александровский Александр Александрович</div>}
                    width={896}
                    placement={'left'}
                    closable={false}
                    onClose={this.hide_drawer_output_day}
                    visible={this.state.visible_output_day}
                    className="auto-order"
                >
                    <Button className="exclude_ts__hide" onClick={this.hide_drawer_output_day} type="primary" shape="circle" icon="close" size={'small'} />
                    <OutputDay hide_drawer_output_day={this.hide_drawer_output_day} orders={this.state.data.select} />
                </Drawer>
                <div className="auto-order__wrap-calendar">
                    <ThreeDatePicker output={output} orders={this.state.data.select} date_range={filtered_info.date_create} />
                </div>
                <Row>
                    <Col span={16}>
                        <div className="auto-order__filters">
                            <Row style={{ width: 500, marginBottom: 16 }} gutter={16}>
                                <Col span={14}>
                                    <Radio.Group defaultValue="active" onChange={this.change_type_data} style={{ width: '100%' }}>
                                        <Radio.Button style={{ width: '50%', textAlign: 'center' }} value="active" disabled={!this.state.archive.length}>План: {this.state.active.length}</Radio.Button>
                                        <Radio.Button style={{ width: '50%', textAlign: 'center' }} value="archive" disabled={!this.state.archive.length}>Архив: {this.state.archive.length}</Radio.Button>
                                    </Radio.Group>
                                </Col>
                                <Col span={10}>
                                    <Search
                                        style={{ width: '100%' }}
                                        placeholder="Поиск по заказам"
                                        onChange={this.handle_search_auto_order_change}
                                        onSearch={this.handle_search_auto_order_search}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ width: 500 }} gutter={16}>
                                <Col span={14}>
                                    <InputGroup compact style={{ width: '100%' }}>
                                        <DatePicker 
                                            onChange={this.change_filter_from_date} 
                                            style={{ width: '50%' }} 
                                            placeholder="от"
                                            format={'DD.MM.YYYY'}
                                            locale={locale}
                                        />
                                        <DatePicker 
                                            onChange={this.change_filter_to_date} 
                                            style={{ width: '50%' }} 
                                            placeholder="до"
                                            format={'DD.MM.YYYY'}
                                            locale={locale}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col span={10}>
                                    <Select 
                                        style={{ width: '100%' }}
                                        allowClear
                                        placeholder="Выберите статус" 
                                        onChange={this.handle_filter_state}
                                    >
                                        <Option value="tobook">Бронь</Option>
                                        <Option value="ready">Готов к вып.</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={8} style={{ textAlign: 'right' }}>
                        <div className="auto-order__buttons">
                            <Button style={{ width: 176, marginBottom: 16  }} onClick={this.show_drawer_pick_new_order}  type="primary">Подобрать новый заказ</Button>
                            <br/>
                            <Button style={{ width: 176 }} onClick={this.show_drawer_output_day} type="danger" ghost>Отметить нерабочие дни</Button>
                        </div>
                    </Col>
                </Row>
                <div className="auto-order__content">
                    {this.render_auto_order_table()}
                    {this.render_auto_order_pages()}
                </div>
                <div className="auto-order__footer">
                    <div className="auto-order__footer-right">
                        <Select 
                            style={{ width: 224, marginRight: 16 }} 
                            placeholder="Выберите действие" 
                            onChange={this.handle_data_event}
                        >
                            <Option value="remove_driver">Снять водителя и ТС с заказа</Option>
                            <Option value="change_driver">Сменить водителя</Option>
                            <Option value="change_vehicle">Сменить ТС</Option>
                        </Select>
                        {this.state.event === 'change_vehicle' && (
                            <Select 
                                style={{ width: 224 }} 
                                placeholder="Выберите ТС"
                                showSearch
                            >
                                <Option value="1">Лиаз, С897КП 61</Option>
                                <Option value="2">Man, T234TC 199</Option>
                                <Option value="3">Setra, K163CO 99</Option>
                                <Option value="4">Mercedes-Benz, M826AB 777</Option>
                                <Option value="5">Setra, P639BO 799</Option>
                            </Select>
                        )}
                        {this.state.event === 'change_driver' && (
                            <Select 
                                style={{ width: 224 }} 
                                placeholder="Выберите водителя"
                                showSearch
                            >
                                <Option value="Абакумов А.Л">Абакумов А.Л</Option>
                                <Option value="Абрамцевский А.Л.">Абрамцевский А.Л.</Option>
                                <Option value="Константинопольский К.К.">Константинопольский К.К.</Option>
                                <Option value="Николаев М.К.">Николаев М.К.</Option>
                                <Option value="Селиванов А.Л.">Селиванов А.Л.</Option>
                            </Select>
                        )}
                    </div>
                    <div className="auto-order__footer-right">
                        <Button style={{ width: 176, marginRight: 16 }} onClick={this.props.handle_close_auto_order} ghost type="primary">Отмена</Button>
                        <Button style={{ width: 176 }} type="primary" disabled={true}>Подтвердить</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Auto_Order;
